import React from 'react';
import { Navigate, Outlet } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import Loader from '../Loader/Loader';

import styles from './ProtectedRoute.module.scss';

const ProtectedRoute = () => {
  const {user, loading} = useAuth();

  if (loading) {
    return <div className={styles.loadingSection}><div className={styles.loader}><Loader variant="dark" size={28} /></div></div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
}; 

export default ProtectedRoute;